import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { KnownReferralType } from '../instrumentation/instrumentation.service';
import { FileType } from '../models/file-item.model';
import { Workload } from '../models/workload.model';

export const enum FirstPartyWorkloadIds {
    Outlook = 'ShellMail',
    Word = 'ShellWordOnline',
    Excel = 'ShellExcelOnline',
    PowerPoint = 'ShellPowerPointOnline',
    OneNote = 'ShellOneNoteOnline',
    Teams = 'ShellSkypeTeams',
    SharePoint = 'ShellSites',
    Delve = 'ShellOfficeGraph',
    Video = 'ShellVideo',
    Project = 'ShellProject',
    Sway = 'ShellSway',
    Forms = 'ShellOfficeForms',
    ClassNotebook = 'ShellClassNotebook',
    Admin = 'ShellAdmin',
    Access = 'ShellAccess',
    Publisher = 'ShellPublisher',
    Visio = 'ShellVisioOnline',
    OneDrive = 'ShellDocuments',
    Calendar = 'ShellCalendar',
    Yammer = 'ShellYammer',
    Dynamics365 = 'ShellDynamics365',
    People = 'ShellPeople',
    Planner = 'ShellHighLander',
    Flow = 'ShellLogicFlows',
    PowerBIv2 = 'ShellPowerBIv2',
    PowerBI = 'ShellPowerBI',
    PowerApps = 'ShellPowerApps',
    Stream = 'ShellMicrosoftStream',
    DynamicsCRM = 'ShellCRM',
    DynamicsERP = 'ShellERP',
    DynamicsMarketing = 'ShellMarketing',
    Bookings = 'ShellBookings',
    BusinessCenter = 'ShellBusinessCenter',
    MyAnalytics = 'ShellMyAnalytics',
    Parature = 'ShellParature',
    SkypeMeetings = 'ShellSkypeMeetings',
    Skype = 'ShellSkype',
    DynamicsNAV = 'ShellDynamicsNAV',
    SocialEngagement = 'ShellNetbreeze',
    Newsfeed = 'ShellNewsfeed',
    OfficeStore = 'ShellOfficeStore',
    ComplianceCenter = 'ShellComplianceCenter',
    Kaizala = 'ShellKaizala',
    Tasks = 'ShellTasks',
    NonProfitPortal = 'ShellNonProfitPortal',
    ToDo = 'ShellToDo',
    StaffHub = 'ShellStaffHub',
    StaffNotebook = 'ShellStaffNotebook',
    Invoicing = 'ShellInvoicing'
}

/**
* Service that retrieves workload items as JSON.
*/
@Injectable()
export abstract class WorkloadsService {

    public abstract getProvisionedWorkloads(): Promise<Array<Workload>>;

    // Only to get new shell workloads with only frequent apps with clicks
    public abstract getCoreSegmentAndFrequentApps(): Promise<Array<Workload>>;

    // Get all available workloads
    public abstract getWorkloads(): Promise<Array<Workload>>;

    public abstract getPinnedWorkloads(): Array<Workload>;

    public abstract unpinWorkload(workloadToUnpin: Workload);

    public abstract getWorkloadId(fileType: FileType): string;

    public abstract getReferralType(workload: Workload): KnownReferralType;

    public abstract getDisplayedApps(workloads: Array<Workload>): string;

    // Returns frequent apps with clicks
    public abstract getFrequentAppsWithAnyClicks(apps: Array<Workload>): Array<Workload>;

    public abstract getThirdPartyWorkloads(): Observable<Array<Workload>>;

    public abstract updateUsedThirdPartyApps(app: Workload);

    public abstract populateWorkloadFields(workloads: Array<Workload>);

    // TODO: Combine with getWorkloads to return observable. Currently only used in pwa.
    public abstract getAdditionalWorkloads(): Promise<Array<Workload>>;

    public abstract pinWorkload(workload: Workload): void;

    public abstract getInAppNav(workloadId: string): boolean;

    public abstract getFileType(workloadId: string): FileType;
}
